import { useState } from "react";
import { CreditCard, CalendarClock, Loader2 } from "lucide-react";
import { startCheckout } from "../lib/payments";

// total, installmentAmount / installment3Amount are display strings like "$799" / "$399.50"
export const PaymentButtons = ({
  total,
  fullKey,
  installmentKey,
  installmentAmount,
  installment3Key,
  installment3Amount,
  testid = "pay",
}) => {
  const [loading, setLoading] = useState(null);

  const go = async (key, which) => {
    setLoading(which);
    await startCheckout(key);
    setLoading(null);
  };

  return (
    <div className="w-full">
      <div className="flex items-baseline justify-between border-b border-amber-500/15 pb-3 mb-4">
        <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">
          Total Balance
        </span>
        <span className="font-serif text-3xl font-black text-gold-foil leading-none">
          {total}
        </span>
      </div>

      <button
        onClick={() => go(fullKey, "full")}
        disabled={loading}
        data-testid={`${testid}-full-btn`}
        className="w-full inline-flex items-center justify-center gap-3 bg-gold-foil text-black text-[13px] font-bold tracking-[0.12em] uppercase px-6 py-4 hover:brightness-110 transition-all duration-300 disabled:opacity-60"
      >
        {loading === "full" ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <CreditCard className="h-4 w-4" />
        )}
        Pay Total Balance
      </button>

      <div className="mt-4 rounded-none border border-amber-500/25 bg-amber-500/5 p-4">
        <p className="text-[13px] text-zinc-300 mb-3">
          Can't cover the full amount today?{" "}
          <span className="text-amber-300 font-medium">Split it into easy payments.</span>
        </p>

        <div className="space-y-2.5">
          <button
            onClick={() => go(installmentKey, "x2")}
            disabled={loading}
            data-testid={`${testid}-installment-btn`}
            className="w-full inline-flex items-center justify-between gap-2.5 border border-amber-500/50 text-amber-200 px-5 py-3 hover:bg-amber-500 hover:text-black transition-colors duration-300 disabled:opacity-60 group/opt"
          >
            <span className="inline-flex items-center gap-2.5 text-[12px] font-bold tracking-[0.1em] uppercase">
              {loading === "x2" ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <CalendarClock className="h-4 w-4" />
              )}
              2 Easy Payments
            </span>
            <span className="font-serif text-lg font-bold">{installmentAmount}</span>
          </button>

          {installment3Key && (
            <button
              onClick={() => go(installment3Key, "x3")}
              disabled={loading}
              data-testid={`${testid}-installment3-btn`}
              className="w-full inline-flex items-center justify-between gap-2.5 border border-amber-500/50 text-amber-200 px-5 py-3 hover:bg-amber-500 hover:text-black transition-colors duration-300 disabled:opacity-60"
            >
              <span className="inline-flex items-center gap-2.5 text-[12px] font-bold tracking-[0.1em] uppercase">
                {loading === "x3" ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  <CalendarClock className="h-4 w-4" />
                )}
                3 Easy Payments
              </span>
              <span className="font-serif text-lg font-bold">{installment3Amount}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
